import Accordion from './Accordion'
import TwoColumnsAccordion from './TwoColumnsAccordion'

export { TwoColumnsAccordion }
export default Accordion
